import { useQuery } from "@tanstack/react-query";
import { t } from "ttag";

import { ErrorState } from "@/app/components/legacy-components";
import { billingQueriesStore } from "@/features/billing/api";
import { History2Icon } from "@/shared/ui";
import { Heading } from "@/shared/ui/common/heading";
import { TableSkeleton } from "@/shared/ui/common/table-skeleton";
import { PaymentHistoryCards, PaymentHistoryTable } from "./components";

export const PaymentHistory = () => {
  const {
    data: paymentHistory,
    isLoading,
    isSuccess,
    isError,
  } = useQuery(billingQueriesStore.payments._ctx.history);

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-wrap items-center justify-between">
        <Heading level={2} size="x-small" icon={History2Icon}>
          {t`Payment history`}
        </Heading>

        <small className="pl-6 text-xs text-neutral-600 md:text-sm">
          {t`Amount reflects the total after applied coupons`}
        </small>
      </div>

      <div className="grow">
        {isLoading && <TableSkeleton columns={7} rows={3} />}

        {isSuccess && (
          <>
            <PaymentHistoryTable payments={paymentHistory} />
            <PaymentHistoryCards payments={paymentHistory} />
          </>
        )}

        {isError && <ErrorState />}
      </div>
    </div>
  );
};
